import React from 'react';
import { useQuery } from 'react-query';
import Link from 'next/link';
import { Icon, Typography } from '@scale/scaleui';
import { fetchWebinarSessionRecording } from '../api';

interface ZoomRecordingsProps {
  session: any;
}

export const ZoomRecordings: React.FC<ZoomRecordingsProps> = ({ session }) => {
  const { data: r, isLoading: recordingLoading } = useQuery(
    ['zoom-recording', session._id],
    () => fetchWebinarSessionRecording(session._id),
    { staleTime: 60 * 60 * 1000, enabled: !!session },
  );
  const recording = r?.recording;

  return (
    <div className="flex items-start gap-1">
      <Typography.Subtitle3>Recordings:</Typography.Subtitle3>
      {recordingLoading ? (
        <Typography.Paragraph2>Loading...</Typography.Paragraph2>
      ) : (
        <>
          {recording?.recordingPlayPasscode && recording?.recordingFiles?.length ? (
            <div className="flex flex-col gap-1 mt-[-2px]">
              {recording.recordingFiles.map((file: any) => (
                <div className="flex gap-1 items-center" key={file.id}>
                  <Link
                    href={
                      file?.play_url
                        ? `${file?.play_url?.replace('remotasks', 'outlier-ai')}?pwd=${
                            recording.recordingPlayPasscode
                          }`
                        : `${file?.download_url.replace('remotasks', 'outlier-ai')}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-500 flex items-center"
                  >
                    {file?.play_url ? 'View Recording' : 'Download Recording'}(
                    {file.recording_type.split('_').join(' ')})
                    <Icon icon="external-link" size="sm" variant="primary" />
                  </Link>
                  <Typography.Paragraph2>
                    {file?.play_url ? '' : ` Password: ${recording?.password}`}
                  </Typography.Paragraph2>
                </div>
              ))}
            </div>
          ) : (
            <Typography.Paragraph2>Does not exist</Typography.Paragraph2>
          )}
        </>
      )}
    </div>
  );
};
